// extracted by mini-css-extract-plugin
export default {"body":"gratitude_body__QEs6l","gracias":"gratitude_gracias__7+wgK","img":"gratitude_img__n1cm1","icon":"gratitude_icon__uUNxU"};